(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-offer-room-type', {
            parent: 'entity',
            url: '/lead-offer-room-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadOfferRoomType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-types.html',
                    controller: 'LeadOfferRoomTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadOfferRoomType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-offer-room-type-detail', {
            parent: 'entity',
            url: '/lead-offer-room-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadOfferRoomType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-type-detail.html',
                    controller: 'LeadOfferRoomTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadOfferRoomType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadOfferRoomType', function($stateParams, LeadOfferRoomType) {
                    return LeadOfferRoomType.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-offer-room-type.new', {
            parent: 'lead-offer-room-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-type-dialog.html',
                    controller: 'LeadOfferRoomTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                discussedPrice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-offer-room-type', null, { reload: true });
                }, function() {
                    $state.go('lead-offer-room-type');
                });
            }]
        })
        .state('lead-offer-room-type.edit', {
            parent: 'lead-offer-room-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-type-dialog.html',
                    controller: 'LeadOfferRoomTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadOfferRoomType', function(LeadOfferRoomType) {
                            return LeadOfferRoomType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-offer-room-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-offer-room-type.delete', {
            parent: 'lead-offer-room-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-offer-room-type/lead-offer-room-type-delete-dialog.html',
                    controller: 'LeadOfferRoomTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadOfferRoomType', function(LeadOfferRoomType) {
                            return LeadOfferRoomType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-offer-room-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
